import { DIMENSIONS } from "utils/Dimensions";
import { renderTextValue } from "../MultiLine/MultiLineColumnRenderer";

export default function TextColumnRenderer(params) {
  return (
    '<div\
      class="textCell"\
      style="width: ' + (Number(params.colDef.width) - 25) + 'px;"\
    >\
        <div\
          class="textCellValue"\
          style="width: ' + (Number(params.colDef.width) - 25) + 'px;\
            white-space:\
              ' + (params.node.rowHeight <= DIMENSIONS.cell_height_short
                ? "nowrap"
                : "nowrap") + '"\
        >\
          '+renderTextValue(params)+'\
        </div>\
    </div>'
  );
}
